import posthog from 'posthog-js';

export function initAnalytics(): void {
  posthog.init('phc_zZKEt2nHaLeF8U2f9LTc6mxoHpspQAzmFZPNdjagrJgY', {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'never',
    autocapture: false,
    capture_pageview: true,
    capture_pageleave: true,
  });
}

export function track(event: string, props?: Record<string, unknown>): void {
  posthog.capture(event, props);
}
